<template>
  <sidebar-wrapper>
    <template v-slot:title>
      <div v-if="isOperator && currentChatUser" class="d-flex justify-content-between">
        <div class="d-flex flex-column">
          <div class="d-flex align-items-center">
            <i class="fas fa-arrow-left me-2" @click.prevent="selectOperatorUser"/>
            <span>{{currentChatUser.profile.display_name}}</span>
          </div>

          <router-link
            :to="`/user/${currentChatUser.username}/profile`"
            href="#" class="text-gray"
          >
            <small class="text-sm">{{$t('edit_profile')}}</small>
          </router-link>
        </div>

        <a
          href="#"
          data-bs-toggle="modal"
          data-bs-target="#new-chat-multiple"
          class="text-sm text-gray"
        >
          Spam
        </a>

        <a
          href="#"
          data-bs-toggle="modal"
          data-bs-target="#new-chat"
          class="text-sm text-gray"
        >
          {{ $t('start_new_chat') }}
        </a>
      </div>

      <span v-else>
        <span>{{$t('chat_list_title')}}</span>

        <span v-if="messageLimitExceeded" class="text-danger text-sm d-block">
          {{$t('chat_trial_exceeded_messages')}} <router-link to="/subscription" class="text-decoration-underline text-primary">{{$t('chat_trial_upgrade_now')}}</router-link>
        </span>
        <span v-else-if="currentChatUser?.subscription?.plan.name === 'trial'" class="text-danger text-sm d-block">{{$t('chat_trial_text')}}</span>
      </span>

      <div class="chat-search-input">
        <form>
          <input
            type="text"
            name="chat-search"
            placeholder="Search"
            class="form-control search-input w-full"
            @input="$emit('search', $event.target.value)"
          />
        </form>
      </div>
    </template>

    <p v-if="!uniqueConversations.length" class="text-center py-2 text-gray">
      <a-empty description="No chats"/>
    </p>

    <ul class="user-list">
      <li class="user-list-item" v-for="conversation in uniqueConversations" :key="conversation.id">
        <router-link
          :class="{'bg-unseen': unseenMessagesForUser(conversation, 'current')}"
          :to="{name: 'chat-conversation', params: {id: conversation.user.username}}"
          @click.prevent="clickConv(conversation.user.username)"
        >
          <UserAvatar :user="conversation.user" online/>

          <div class="users-list-body">
            <div class="text-truncate">
              <h5>
                {{ conversation.user.profile.display_name }}
                <span v-if="conversation.id === 'new'" class="text-primary">(New)</span>
              </h5>

              <p>
                <span v-if="conversationTyping(conversation.id)">
                  <Typing text="Typing"/>
                </span>

                <span v-else-if="conversation.messages.length">{{ lastMessage(conversation)?.content }}</span>
                <span v-else-if="conversation.id === 'new'" class="text-primary">Send first message</span>
              </p>
            </div>

            <div v-if="conversation.messages.length" class="last-chat-time">
              <small class="text-muted">{{ conversationTimeFormat(lastMessage(conversation)?.timestamp) }}</small>

              <div class="chat-pin">
                <div v-if="unseenMessagesForUser(conversation, 'current')" class="new-message-count me-2">
                  {{ unseenMessagesForUser(conversation, 'current') }}
                </div>

                <i v-else-if="unseenMessagesForUser(conversation, 'other')" class="bx bx-check-double me-2"/>
                <i v-else class="bx bx-check-double check me-2"/>
              </div>
            </div>
          </div>
        </router-link>
      </li>
    </ul>
  </sidebar-wrapper>
</template>

<script>
import ChatSidebar from "@/assets/json/frontend/chat-sidebar.json";
import {mapGetters} from "vuex";
import {conversationTimeFormat} from '@/util';
import UserAvatar from "@/components/frontend/UserAvatar";

export default {
  components: {UserAvatar},
  data() {
    return {
      ChatSidebar: ChatSidebar,
    };
  },

  watch: {
    $route: {
      handler() {
        if (this.$route.params.id) {
          this.selectConversation(this.$route.params.id);
        }

        if (this.$route.name === 'chat-conversation') {
          this.$nextTick(() => {
            this.$eventHub.$emit('toggleChat', true);
            this.$eventHub.$emit('toggleMenu', false);
          });
        }
      },
      immediate: true,
    },
  },

  computed: {
    ...mapGetters({
      lastMessage: 'chat/lastMessage',
      messageLimitExceeded: 'chat/messageLimitExceeded',
      conversations: 'chat/conversations',
      activeUsers: 'chat/activeUsers',
      unseenMessagesForUser: 'chat/unseenMessagesForUser',
      conversationTyping: 'chat/conversationTyping',
      newMessagesCount: 'chat/newMessagesCount',
      people: 'people',
      currentChatUser: 'chat/currentChatUser',
      isOperator: 'isOperator',
    }),

    uniqueConversations() {
      return this.conversations.filter(e => e.messages.length || e.toBeInitiated);
    },
  },

  methods: {
    conversationTimeFormat,

    clickConv(username) {
      if (this.$route.name === 'chat-conversation') {
        this.$eventHub.$emit('toggleChat', true);
        this.$eventHub.$emit('toggleMenu', false);
      } else {
        this.$router.push({name: 'chat-conversation', params: {id: username}});
      }
    },

    async selectConversation(username, conversation = null) {
      this.$eventHub.$emit('toggleChat', true);
      this.$eventHub.$emit('toggleMenu', false);

      if (!conversation) {
        conversation = this.conversations.find(e => e.user.username === username);

        if (!conversation) {
          // Start new conversation
          conversation = await this.$store.dispatch('chat/startConversation', {username});
        }
      }

      if (conversation && conversation.id !== 'new') {
        this.$store.dispatch('chat/markConversationAsRead', {conversation, messagesForUserId: conversation.user.id});
      }
    },

    selectOperatorUser() {
      this.$store.commit('chat/setCurrentChatUser', null);
    },
  },
};
</script>
